//   This files handles the parsing of the categories being followed

export function parseAdPlatformSettingsByClient(adPlatformSettingsByClient) {
  return adPlatformSettingsByClient;
}
